import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Label, Input, PrimaryBtn, GhostBtn } from "@/components/admin/ui";
import { Plus, Trash2, Phone } from "lucide-react";

const FIELDS = [
  { key: "whatsapp", label: "WhatsApp (numero, es. +39333…)" },
  { key: "email", label: "Email" },
  { key: "instagram", label: "Instagram (handle o URL)" },
  { key: "twitch", label: "Twitch (canale o URL)" },
  { key: "facebook", label: "Facebook (pagina o URL)" },
  { key: "youtube", label: "YouTube (canale o URL)" },
];

const empty = { whatsapp: "", email: "", instagram: "", twitch: "", facebook: "", youtube: "", custom: [] };

export default function ContactsPanel() {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/contacts").then((r) => {
      setForm({ ...empty, ...r.data, custom: r.data.custom || [] });
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setCustom = (i, k, v) => {
    const next = [...(form.custom || [])];
    next[i] = { ...next[i], [k]: v };
    setForm({ ...form, custom: next });
  };
  const addCustom = () => setForm({ ...form, custom: [...(form.custom || []), { label: "", value: "" }] });
  const delCustom = (i) => setForm({ ...form, custom: form.custom.filter((_, idx) => idx !== i) });

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/contacts", form);
      toast.success("Contatti aggiornati");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg" data-testid="contacts-panel">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold uppercase text-zinc-100 mb-2">
        <Phone className="h-5 w-5 text-yellow-400" /> Contatti amministratore
      </h2>
      <p className="text-sm text-zinc-500 mb-6">Questi contatti sono mostrati nella pagina pubblica “Contatti”. Lascia vuoto ciò che non vuoi mostrare.</p>

      <div className="space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <Label>{f.label}</Label>
            <Input value={form[f.key] || ""} onChange={set(f.key)} className="mt-2" data-testid={`contact-input-${f.key}`} disabled={!loaded} />
          </div>
        ))}

        <div>
          <div className="flex items-center justify-between">
            <Label>Altri contatti / canali</Label>
            <GhostBtn onClick={addCustom} data-testid="add-custom-contact"><Plus className="h-4 w-4" /> Aggiungi</GhostBtn>
          </div>
          <div className="mt-2 space-y-2">
            {(form.custom || []).map((x, i) => (
              <div key={i} className="grid grid-cols-12 gap-2 items-center">
                <Input placeholder="Etichetta (es. Telegram)" value={x.label || ""} onChange={(e) => setCustom(i, "label", e.target.value)} className="col-span-5" data-testid={`custom-label-${i}`} />
                <Input placeholder="Valore o link" value={x.value || ""} onChange={(e) => setCustom(i, "value", e.target.value)} className="col-span-6" data-testid={`custom-value-${i}`} />
                <button onClick={() => delCustom(i)} data-testid={`del-custom-${i}`} className="col-span-1 justify-self-end text-zinc-500 hover:text-red-400 transition-colors duration-200 p-2">
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <PrimaryBtn onClick={save} disabled={saving || !loaded} data-testid="save-contacts-btn">
          {saving ? "Salvataggio…" : "Salva contatti"}
        </PrimaryBtn>
      </div>
    </div>
  );
}
